<template>
  <div class="lobby__bg">
    <v-row>
      <!-- Main Content -->
      <v-col cols="12">
        <div class="content__box lobby__bg-text" v-if="isEventFetched">
          <div :class="[authenticated ? '' : 'eventdetails__normal-padding',
          { 'top-zero-imp': checkIsExternalPage }]" class="publicmodal__sticky">
            <div
              class="d-flex align-center justify-center justify-sm-space-between flex-column flex-sm-row pt-sm-3 pr-sm-3">
              <div>
                <div v-if="!checkIsExternalPage">
                  <v-btn medium text class="publicmodal__sticky-back" :to="{ name: 'dashboard' }"
                    :target="openInNewTabIfExternalPage">
                    <v-icon left>mdi-arrow-left</v-icon> {{ $t('public_event.back') }}
                  </v-btn>
                </div>
              </div>
              <!-- Event Title -->
              <div class="text-center">
                <h1 class="content__box-title eventdetails__main-titletext mb-0">{{ singlePublicEvent.name }}</h1>
                <p class="mb-sm-0 lobby__bg-text"> {{ eventCompanyName }} </p>
              </div>
              <BookTickets v-if="!isAccountRestricted" :tickets-with-active-window="ticketsWithActiveWindow"
                :event-data="eventInfo" />
            </div>
            <v-divider></v-divider>
          </div>
          <v-row class="lobby__bg-text">
            <!-- Event images -->
            <v-col cols="12" md="6" v-if="showMainImage === 'true'">
              <RaMediaDisplay location="primary" :media="singlePublicEvent.media" :sizes="sizes"
                class="eventdetails__public-img" />
            </v-col>
            <!-- Event Date info -->
            <v-col cols="12" md="6">
              <div class="d-flex justify-space-between flex-column flex-sm-row">
                <div class="eventdetails__date">
                  <p class="eventdetails__date-info">{{ $t('public_event.event_starts') }}</p>
                  <h4 class="eventdetails__date-title">
                    <v-icon class="eventdetails__date-icon">mdi-calendar-month-outline</v-icon>
                    {{ formatDate(singlePublicEvent.schedule.event_start_date_time) }}
                  </h4>
                  <h6 class="eventdetails__date-time">
                    <v-icon class="eventdetails__date-icon">mdi-clock-outline</v-icon>
                    {{ formatTime(singlePublicEvent.schedule.event_start_date_time) }} {{ timeZoneCountry }}

                  </h6>
                </div>
                <div class="eventdetails__date">
                  <p class="eventdetails__date-info">{{ $t('public_event.event_ends') }}</p>
                  <h4 class="eventdetails__date-title">
                    <v-icon class="eventdetails__date-icon">mdi-calendar-month-outline</v-icon>
                    {{ formatDate(singlePublicEvent.schedule.event_end_date_time) }}
                  </h4>
                  <h6 class="eventdetails__date-time">
                    <v-icon class="eventdetails__date-icon">mdi-clock-outline</v-icon>
                    {{ formatTime(singlePublicEvent.schedule.event_end_date_time) }} {{ timeZoneCountry }}
                  </h6>
                </div>
              </div>
              <div v-if="showDescription === 'true'">
                <h4 class="eventdetails__subtitle mb-2">{{ $t('public_event.description') }}</h4>
                <p class="eventdetails__subdesc" v-html="singlePublicEvent.description">
                </p>
              </div>
            </v-col>
          </v-row>

          <!-- Sponsored -->
          <v-row align="center d-flex justify-space-between " v-if="hasSponsors">
            <v-col cols="12">
              <h4 class="eventdetails__subtitle">{{ $t("public_event.sponsored_By") }}</h4>
            </v-col>
            <template v-for="sponsor in singlePublicEvent.sponsors">
              <v-col :key="sponsor.id" sm="4" md="3" cols="6" lg="2" class="mb-5 eventdetails__sponser">
                <RaMediaDisplay location="primary" :media="sponsorImage(sponsor.attachments)" :sizes="sponsorSize" />
              </v-col>
            </template>

          </v-row>

          <!-- event group -->
          <v-row v-if="showSchedule === 'true'">
            <v-col cols="12 d-flex justify-space-between">
              <h2 class="eventdetails__subtitle">{{ $t('public_event.schedule') }}</h2>
              <div class="d-flex justify-space-between flex-wrap flex-column-reverse flex-md-row align-md-end "
                :class="{ 'text--disabled': !authenticated }">
                <div class="timezone timezone__widget timezone__widget-public" tabindex="23" aria-label="my timezone">
                  <div class="timezone__details" aria-label="my timezone" @click="changeUserTimezone">
                    <div>
                      <h6 class="timezone__country lobby__bg-text">
                        {{ userBiggestPlace }}
                      </h6>
                      <p class="timezone__paragraph lobby__bg-text">
                        {{ userStandardTimezone }}
                      </p>
                    </div>
                    <v-img class="timezone__img" :src="userCountryFlag" />
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <template v-for="(singleSchedule, index) in publicSchedules">
                <div :key="index" class="eventdetails__schedule" @click="showScheduleModal(singleSchedule)">
                  <v-row>
                    <v-col cols="4" md="2">
                      <RaMediaDisplay location="primary" :media="singleSchedule.media" :sizes="scheduleSizes" />
                    </v-col>
                    <v-col cols="8" md="7">
                      <h3 class="eventdetails__schedule-title">
                        {{ singleSchedule.name }}
                      </h3>
                      <p class="eventdetails__schedule-desc" v-html="singleSchedule.description">
                      </p>
                      <!-- Pills -->
                      <div class="d-flex align-center flex-wrap">
                        <div v-for="(room, index) in singleSchedule.rooms" :key="room.id" class="event__pills me-2"
                          :class="roomClass(index)">
                          {{ room }}
                        </div>
                        <div class="event__pills me-2" :class="'schedule__' + singleSchedule.type">
                          {{ singleSchedule.group_name }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" md="3" class="mt-2 mt-md-0">
                      <p class="mb-0 d-flex align-center flex-wrap">
                        <span>
                          <v-icon class="eventdetails__schedule-date--icon">mdi-calendar-month-outline</v-icon>
                          {{ formatDate(singleSchedule.event_start_date_time) }}
                        </span>
                        <span class="px-1"></span>
                        <span>
                          <v-icon class="eventdetails__schedule-date--icon">
                            mdi-clock-outline</v-icon>
                          {{ formatTime(singleSchedule.event_start_date_time) }}
                        </span>
                      </p>
                    </v-col>
                  </v-row>
                  <!-- Presenters -->
                  <v-row class="eventdetails__schedule-presentersbox">
                    <v-col cols="12" lg="2">
                      <div class="text-lg-end" v-if="singleSchedule.presenters.length > 0">
                        <h3 class="eventdetails__schedule-title mt-lg-2 mb-1">
                          {{ $t('public_event.presenters') }}
                        </h3>
                      </div>
                    </v-col>
                    <v-col cols="12" lg="10">
                      <div class="d-flex flex-wrap" v-if="singleSchedule.presenters.length > 0">
                        <RaSessionPresenter v-for="presenter in singleSchedule.presenters" :key="presenter.id"
                          :presenter="presenter" />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </template>
              <!-- View schedulemodal per session-->
              <v-dialog v-if="sessionDetails" v-model="schedulemodal" width="900">
                <v-card class="event-modal__wrap ra lobby__bg">
                  <div class="ra__form-heading lobby__bg">
                    <v-card-title class="ra__modal-title">
                      <h3 class="ra__modal-title--heading lobby__bg-text">
                        {{ $t('public_event.schedule') }}
                      </h3>
                    </v-card-title>
                    <ra-modal-close-button light @close-modal="closeScheduleModal" />
                  </div>
                  <v-card-text class="eventdetails__schedule-modal">
                    <v-row>
                      <v-col cols="12" md="5">
                        <RaMediaDisplay location="primary" :media="sessionDetails.media" :sizes="sizes"
                          class="eventdetails__schedule-contian" />
                      </v-col>
                      <v-col cols="12" md="7">
                        <h3 class="eventdetails__schedule-modal--title mt-2 mt-md-0 lobby__bg-text">
                          {{ sessionDetails.name }}
                        </h3>
                        <p class="eventdetails__schedule-modal--desc lobby__bg-text" v-html="sessionDetails.description">
                        </p>

                        <div v-for="(room, index) in sessionDetails.rooms" :key="room.id" class="event__pills me-2"
                          :class="roomClass(index)">
                          {{ room }}
                        </div>
                        <div class="event__pills me-2" :class="'schedule__' + sessionDetails.type">
                          {{ sessionDetails.group_name }}
                        </div>
                      </v-col>
                      <v-col v-if="sessionDetails.type == 'EventPlayer'" cols="12" class="mt-4">
                        <v-row>
                          <v-col cols="12" sm="5">
                            <h3 data-v-418863d3="" class="eventdetails__schedule-modal--title text-md-end lobby__bg-text">
                              {{ $t('public_event.start_date') }}
                            </h3>
                          </v-col>
                          <v-col cols="12" sm="7">
                            <p class="eventdetails__schedule-modal--date d-flex align-center flex-wrap lobby__bg-text">
                              <span>
                                <v-icon
                                  class="eventdetails__schedule-modal--date--icon">mdi-calendar-month-outline</v-icon>
                                {{ formatDate(sessionDetails.event_start_date_time) }}
                              </span>
                              <span class="px-1"></span>
                              <span>
                                <v-icon class="eventdetails__schedule-modal--date--icon">
                                  mdi-clock-outline</v-icon>
                                {{ formatTime(sessionDetails.event_start_date_time) }}
                              </span>
                            </p>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="5">
                            <h3 data-v-418863d3="" class="eventdetails__schedule-modal--title text-md-end lobby__bg-text">
                              {{ $t('public_event.end_date') }}
                            </h3>
                          </v-col>
                          <v-col cols="12" sm="7">
                            <p class="eventdetails__schedule-modal--date d-flex align-center flex-wrap lobby__bg-text">
                              <span>
                                <v-icon
                                  class="eventdetails__schedule-modal--date--icon">mdi-calendar-month-outline</v-icon>
                                {{ formatDate(sessionDetails.event_end_date_time) }}
                              </span>
                              <span class="px-1"></span>
                              <span>
                                <v-icon class="eventdetails__schedule-modal--date--icon">
                                  mdi-clock-outline</v-icon>
                                {{ formatTime(sessionDetails.event_end_date_time) }}
                              </span>
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <div class="eventdetails__schedule my-2" v-if="hasPresenters">
                          <div class="text-center">
                            <h3 class="eventdetails__schedule-modal--title mb-1  lobby__bg-text">
                              {{ $t('public_event.presenters') }}
                            </h3>
                          </div>
                          <div class="d-flex align-center justify-center flex-wrap">
                            <RaSessionPresenter v-for="presenter in sessionDetails.presenters" :key="presenter.id"
                              :presenter="presenter" />
                          </div>
                        </div>
                      </v-col>
                    </v-row>

                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </div>
        <WelcomeModal v-if="authenticated" ref="welcomeModal" />
      </v-col>

      <v-dialog v-model="showNotPublishDialog" max-width="480">
        <v-card>
          <div class="ra__form-heading">
            <v-card-title class="ra__modal-title">
              Alert
            </v-card-title>
            <v-btn icon @click="showNotPublishDialog = false" aria-label="Close popup window">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="pt-3 px-3 px-lg-8">
            <template v-if="!isEventPublished">
              The public event page for this event is not currently accessible to the public as your event is not yet
              published. This means that any tickets you have for sale, or listed as free, cannot currently be
              accessed.<br>To make this event public, publish your event in the Event Builder.<br>
            </template>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="showNotPublishDialog = false">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="eventRemoved" max-width="480">
        <v-card>
          <div class="ra__form-heading">
            <v-card-title class="ra__modal-title">
              Alert
            </v-card-title>
            <v-btn icon @click="eventRemoved = false" aria-label="Close popup window">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="pt-3 px-3 px-lg-8" v-html="$t('event_removed')">
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="eventRemoved = false">
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showPlanNotActiveDialog" persistent max-width="480">
        <v-card>
          <div class="ra__form-heading">
            <v-card-title class="ra__modal-title">
              Alert
            </v-card-title>
          </div>
          <div class="pb-3 pt-3 px-3 px-lg-8">
            {{ $t('event_can_not_be_displayed') }}
          </div>
        </v-card>
      </v-dialog>
      <RaAccountRestrictModal />
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import RaMediaDisplay from '~/components/media/RaMediaDisplay'
import moment from 'moment'
import mediaHandler from '~/plugins/media/mediaHandler'
import { formattedPrice } from '~/plugins/billing/billing'
import RaModalCloseButton from '~/components/general/RaModalCloseButton'
import BookTickets from '~/components/BookTickets'
import RaSessionPresenter from '~/components/lobby/RaSessionPresenter'
import { setOpacityToHexCode } from '~/plugins/helpers'
import WelcomeModal from '~/components/WelcomeModal'
import RaAccountRestrictModal from '~/components/general/RaAccountRestrictModal.vue'
import isEmpty from 'lodash/isEmpty'

export default {
  layout: "default",
  components: { RaMediaDisplay, RaModalCloseButton, BookTickets, RaSessionPresenter, WelcomeModal, RaAccountRestrictModal },
  metaInfo() {
    return {
      title: this.$t("public_event.public_event_page"),
    };
  },
  props: {
    showMainImage: {
      type: String,
      default: 'true'
    },
    showDescription: {
      type: String,
      default: 'true'
    },
    showSchedule: {
      type: String,
      default: 'true'
    },
    showTickets: {
      type: String,
      default: 'true'
    },
    isExternalPage: {
      type: String,
      default: 'false'
    },
  },
  data: () => ({
    ticketList: [],
    sizes: '(min-width:360px) 80vw, (min-width:600px ) 60vw, (min-width:1264px) 50vw, (min-width:1904px)100vw, 100vw',
    sponsorSize: '(min-width:360px) 80vw, (min-width:600px ) 60vw, (min-width:1264px) 50vw, (min-width:1904px)100vw, 100vw',
    scheduleSizes: '(min-width:375px) 75vw, (min-width:600px ) 65vw, (min-width:960px) 60vw,(min-width:1264px) 55vw, (min-width:1904px)100vw, 100vw',
    showNotPublishDialog: false,
    planIsActive: false,
    isEventPublished: false,
    eventRemoved: false,
    showPlanNotActiveDialog: false,
    schedulemodal: false,
    isAccountRestricted: false,
    sessionDetails: null,
    root: {},
    isEventFetched: false

  }),
  async created() {
    this.root = document.documentElement;
    if (this.eventId && await this.isPageVisible()) {
      await this.showLoader(true)
      await this.getPublicSchedules(this.eventId)
      await this.getPublicEvent({ id: this.eventId }).then(() => {
        let advanced_graphics_choice = this.singlePublicEvent.advanced_graphics_choice;
        this.$nextTick(() => {
          if (advanced_graphics_choice?.id) {
            this.root.style.setProperty("--ra-lobby-card_font_colour", advanced_graphics_choice.card_font_colour);
            this.root.style.setProperty("--ra-lobby-main_font_colour", advanced_graphics_choice.main_font_colour);
            this.root.style.setProperty("--ra-lobby-sidebar_selected_colour", advanced_graphics_choice.sidebar_selected_colour);
            this.root.style.setProperty("--ra-lobby-sidebar_selected_font_colour", advanced_graphics_choice.sidebar_selected_font_colour);
            this.root.style.setProperty("--ra-lobby-sidebar_unselected_colour", advanced_graphics_choice.sidebar_unselected_colour);
            this.root.style.setProperty("--ra-lobby-sidebar_unselected_font_colour", advanced_graphics_choice.sidebar_unselected_font_colour);
            this.root.style.setProperty("--ra-lobby-schedule_container_colour", setOpacityToHexCode(advanced_graphics_choice.schedule_container_colour));
            const url = (advanced_graphics_choice.use_predefined_template || advanced_graphics_choice.use_basic_graphics) ? advanced_graphics_choice.background_image_url : advanced_graphics_choice.background_image?.primary?.images?.large?.x2?.url;
            this.root.style.setProperty("--ra-lobby-background_image", `url('${url}'`);
          }
          this.isEventFetched = true
        })
      })
      await this.showLoader(false)
      if (this.singlePublicEvent && this.singlePublicEvent.is_dark_mode) {
        this.$vuetify.theme.dark = this.singlePublicEvent.is_dark_mode
      }
    }
    this.$root.$on('welcome-modal-close', async () => {
      await this.welcomeModalClose()
    })
  },
  computed: {
    ...mapGetters({ user: 'auth/user', authenticated: 'auth/check' }),
    ...mapGetters('auth', ['user']),
    ...mapGetters('publicEvent', ['singlePublicEvent']),
    ...mapGetters('publicSchedules', ['publicSchedules']),
    eventId() {
      return this.$route.params.eventId;
    },
    eventCompanyName() {
      return this.singlePublicEvent.event_company_name ? `By: ${this.singlePublicEvent.event_company_name}` : '';
    },
    timeZoneCountry() {
      return this.singlePublicEvent.time_zone && this.singlePublicEvent.time_zone.timezone.country_name;
    },
    ticketsWithActiveWindow() {
      // just removed the filter because we are checking in backend
      return this.singlePublicEvent.ticketsForSale
    },
    checkIsExternalPage() {
      return this.isExternalPage === 'true'
    },
    openInNewTabIfExternalPage() {
      return this.checkIsExternalPage ? '_blank' : ''
    },
    refundPolicy() {
      let refundPolicyName;
      const types = window.config.constants.refund_types
      types.map((e) => {
        if (e.key == this.singlePublicEvent.refund_policy) {
          refundPolicyName = e.value;
        }
      })
      return refundPolicyName
    },
    eventInfo() {
      return { eventName: this.singlePublicEvent.name, eventId: this.singlePublicEvent.id, eventCurrency: this.singlePublicEvent.currency_info, refundPolicy: this.refundPolicy, redirectUrl: this.singlePublicEvent.redirect_url, ownerCountry: this.singlePublicEvent.event_owner_country, ownerPlan: this.singlePublicEvent.plans, tax_name: this.singlePublicEvent.tax_name, tax_inclusive_ticket_price: this.singlePublicEvent.tax_inclusive_ticket_price, tax_percentage: this.singlePublicEvent.tax_percentage, is_tax_required: this.singlePublicEvent.is_tax_required }
    },
    timezone() {
      return !(this.authenticated && this.hasTimezone) ? this.singlePublicEvent.time_zone : this.user.timezone
    },
    userBiggestPlace() {
      return `${this.timezone?.location_name}, ${this.timezone?.timezone?.country_name}`
    },
    hasTimezone() {
      return this.user && this.user.timezone && this.user.timezone.hasOwnProperty('id')
    },
    userStandardTimezone() {
      return 'GMT' + this.timezone?.timezone?.standard_offset
    },
    userCountryFlag() {
      return 'https://flagcdn.com/w320/' + this.timezone?.timezone?.country_code + '.png'
    },
    hasSponsors() {
      return this.singlePublicEvent?.sponsors.length > 0
    },
    hasPresenters() {
      return this.sessionDetails.presenters.length > 0
    },
    hasSinglePublic() {
      return !isEmpty(this.publicSchedules) && !!this.publicSchedules
    }
  },
  methods: {
    ...mapActions('publicEvent', ['getPublicEvent']),
    ...mapActions('publicSchedules', ['getPublicSchedules']),
    ...mapActions('schedules', ['setCurrentSession']),
    formatDate(datetime) {
      return moment(datetime).format('Do MMMM, YYYY')
    },
    formatTime(datetime) {
      return moment(datetime).format('h:mm a')
    },
    sponsorImage(attachments) {
      return mediaHandler.getAllMediaForModel('Sponsor', attachments)
    },
    ticketImage(attachments) {
      return mediaHandler.getAllMediaForModel('EventTicket', attachments)
    },
    getGroupName(schedule) {
      return schedule[0].group_name;
    },
    currencyWithCode(value, isoCode) {
      return formattedPrice({ value: value, isoCode: isoCode })
    },
    presenterMedia(media) {
      return mediaHandler.getAllMediaForModel('User', media)
    },
    ifPresentersExist(presenter) {
      return presenter && presenter.length > 0;
    },
    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    close() {
      this.availableTicketModal = false
      this.orderSummary = []
    },
    async isPageVisible() {
      const res = await this.getPageAccess();
      if (res.eventNotFound) {
        this.eventRemoved = true
        return false
      }
      // Check for Event owner account is restricted
      if (res.accountRestricted) {
        this.$store.dispatch('permission/showAccountRestrictPopup', { user: 'normal-user', route: 'public-page' });
        this.isAccountRestricted = true;
        return false;
      }

      this.isEventPublished = res.isPublished
      this.planIsActive = res.isVisible
      const ownerOrTeamMember = this.ownerOrTeamMember(res.userRole.role);
      if (this.planIsActive || ownerOrTeamMember) {
        if (this.isEventPublished) {
          return true
        }
        else if (this.checkIsExternalPage) {
          this.showPlanNotActiveDialog = true
          return false
        }
        else if (ownerOrTeamMember) {
          this.showNotPublishDialog = true
          return true
        }
        else {
          await this.$router.push({ name: 'searchEvent' })
          return false
        }
      }
      else if (this.checkIsExternalPage) {
        this.showPlanNotActiveDialog = true
        return false
      }
      else {
        await this.$router.push({ name: 'searchEvent' })
        return false
      }
    },
    async getPageAccess() {
      let url;
      if (this.authenticated) {
        url = `/event/${this.eventId}/is-public-page-visible`;
      }
      else {
        url = `/event/${this.eventId}/public-page-visible`;
      }
      return axios
        .get(url)
        .then((response) => {
          return response.data
        })
        .catch((error) => (console.log(error)));
    },
    ownerOrTeamMember(role) {
      return (role == 'event-owner' || role == 'team-member')
    },
    roomClass(index) {
      return `schedule__room-${index % 7}`
    },
    closeScheduleModal() {
      this.schedulemodal = false
    },
    showScheduleModal(data) {
      this.sessionDetails = data
      this.schedulemodal = true
    },
    changeUserTimezone() {
      if (this.authenticated) {
        this.$root.$emit('show-timezone-popup', {
          showTimezone: true,
          step: 2,
          openDialog: true
        })
      }
    },
    async welcomeModalClose() {
      await this.showLoader(true)
      this.getPublicSchedules(this.eventId)
      await this.showLoader(false)
    }
  }
};
</script>
